import { getFlexiblePrecision } from './scheduleUtils';
import { PlannerTaskInfo } from './types';

const precisionOrder = { year: 0, month: 1, day: 2, timed: 3 };

const getPrecisionOrder = (taskInfo: PlannerTaskInfo) => {
    const precision = getFlexiblePrecision(taskInfo.task);
    return precisionOrder[precision || 'timed'];
};

export const sortPlannerTasks = (tasks: PlannerTaskInfo[]) => [...tasks].sort((first, second) => {
    if (first.task.completed !== second.task.completed) return first.task.completed ? 1 : -1;

    const startDifference = new Date(first.task.dueDate!).getTime() - new Date(second.task.dueDate!).getTime();
    if (startDifference) return startDifference;

    const precisionDifference = getPrecisionOrder(first) - getPrecisionOrder(second);
    if (precisionDifference) return precisionDifference;

    return first.task.title.localeCompare(second.task.title) || first.task.id.localeCompare(second.task.id);
});
